import { gql } from 'apollo-boost';

export const GET = gql`
  {
    networks {
      id
      name
      description
    }
  }
`;

export const GET_BY_NETWORK_ID = gql`
query network($id: String!) {
  network(id: $id) {
    id
    name
    description
  }
}
`;

export const ADD = gql`
  mutation createNetwork($name: String!, $description: String!) {
    createNetwork(input: { name: $name,description: $description }) {
        id
        name
        description
    }
  }
`;

export const EDIT = gql`
  mutation updateNetwork($id: String!, $name: String!,$description: String!) {
    updateNetwork(id: $id, input: { name: $name, description: $description }) {
        id
        name
        description
    }
  }
`;

export const DELETE = gql`
mutation deleteNetwork($id: String!) {
  deleteNetwork(id: $id) {
    id
  }
}
`;
